module.exports = __webpack_public_path__ + "img/intro-bg-mobile.79fb991b.jpg";